import React from 'react';

const AppContext = React.createContext();

AppContext.displayName = 'ReactLabAppContext';
export default AppContext;
